import { render, staticRenderFns } from "./userAdjustScoreModal.vue?vue&type=template&id=07d4837f&"
import script from "./userAdjustScoreModal.vue?vue&type=script&lang=js&"
export * from "./userAdjustScoreModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports